import type { TraitEntry } from '@/features/playbook/types';

export const traits: TraitEntry[] = [
  {
    slug: 'clerk',
    label: 'Clerk',
    kind: 'virtue',
    effect: 'You gain Academic abilities and scholarly training, allowing you to read and interpret texts beyond the reach of common folk.',
    example: 'When the covenant discovers a dusty manuscript in the library, you can decipher its Latin and recognize which scholars it cites.',
  },
  {
    slug: 'common-sense',
    label: 'Common Sense',
    kind: 'virtue',
    effect: "The storyguide warns you whenever you're about to do something contrary to ordinary good sense.",
    example: 'As you reach for a glowing amulet without testing it first, the GM leans in and asks, are you sure you want to do that?',
  },
  {
    slug: 'covenfolk',
    label: 'Covenfolk',
    kind: 'virtue',
    effect: 'Free Social Status; the covenant provides your standard of living (so you cannot take Wealthy or Poor).',
    example: 'The covenant feeds, clothes, and shelters you without question — you never worry about winter lodging, and your ink and parchment arrive in the scriptorium as if by silent hands.',
  },
  {
    slug: 'social-contacts',
    label: 'Social Contacts',
    kind: 'virtue',
    effect: 'A named social circle (Academics) recognizes you; roll Presence + die vs Ease Factor 6 to make contact when you need them.',
    example: 'When the covenant needs information from a distant monastery, you know someone there by name and can send a letter they will answer.',
  },
  {
    slug: 'humble',
    label: 'Humble',
    kind: 'flaw',
    effect: 'You believe others are more skilled or qualified than you, even when you have equal or greater merit.',
    example: "Even though your Latin is better than the visiting friar's, you assume his reading of the passage must be right and rewrite your draft to match his.",
  },
  {
    slug: 'magical-fascination',
    label: 'Magical Fascination',
    kind: 'flaw',
    effect: 'You are drawn to investigate any magical phenomenon — you ask questions, linger, and pocket oddities even when prudence demands otherwise.',
    example: 'You slip a strangely warm pebble from a faerie ring into your satchel, reasoning you will study it properly later — you do not mention this to the Primus.',
  },
  {
    slug: 'short-of-breath',
    label: 'Short of Breath',
    kind: 'flaw',
    effect: '–3 penalty to Stamina rolls to avoid fatigue and to Concentration rolls during exertion.',
    example: 'After a day of marching toward the distant town, you lag behind the rest of the group and need to rest while they press on.',
  },
  {
    slug: 'humble-trait',
    label: 'Humble',
    kind: 'personality',
    effect: 'You defer to others and doubt your own merit; the GM rolls stress die + 3 when testing whether you assert yourself or step back.',
    example: 'When asked to lead the group, you hesitate and suggest someone more qualified should take the lead instead.',
  },
  {
    slug: 'brave',
    label: 'Brave',
    kind: 'personality',
    effect: 'You instinctively shrink from danger rather than meet it head-on; the GM rolls stress die - 3 when testing your willingness to press forward.',
    example: 'Faced with an armed opponent, your first impulse is to retreat or seek shelter rather than stand your ground.',
  },
  {
    slug: 'perfectionist',
    label: 'Perfectionist',
    kind: 'personality',
    effect: 'You re-read, re-check, and obsess over correctness; the GM rolls stress die + 2 when testing whether you accept sloppy work.',
    example: 'You spend an extra hour reviewing your covenant translation before submitting it, catching three small errors no one else would notice.',
  },
  {
    slug: 'curious',
    label: 'Curious',
    kind: 'personality',
    effect: 'You are driven to know and understand, even when it puts you at risk; the GM rolls stress die + 3 when testing whether you investigate further.',
    example: 'Hearing a rumor of forbidden knowledge in the hermitage, you slip away to the restricted vault despite the danger of being caught.',
  },
];
